<template>
	<layout-admin>
		<!--<h1>hallo user grid!</h1>-->

		<div class="container-fluid">
			<h1 class="my-2">{{ __("Evaluation/analysis") }}</h1>
			<table class="table-auto">
				<tr v-for="(baseUrl, label) in reports" :key="label">
					<td>{{ __(label) }}</td>
					<td>
						<span
							class="text-orange-500 pr-4"
							v-for="(pId, pLabel) in periods"
							:key="pLabel"
						>
							<a :href="refs(baseUrl, pId)">{{ __(pLabel) }}</a>
						</span>
					</td>
				</tr>
			</table>
		</div>
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		reports: {
			type: Object,
			required: true,
		},
		periods: {
			type: Object,
			required: true,
		},
		apiKey: {
			type: String,
			required: true,
		},
	},
	methods: {
		refs(baseUrl, pId) {
			return (
				window.baseUrl +
				"/api/reporting/" +
				baseUrl +
				"&key=" +
				this.apiKey +
				"&period=" +
				pId
			);
		},
	},
};
</script>
